import { useQuery } from "react-query";
import getUnclaimedMoney, {
  UnclaimedMoneyResponse,
} from "../services/getUnclaimedMoney";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";

function useGetUnclaimedMoney(
  token: string,
  pagination: MRT_PaginationState,
  sorting?: MRT_SortingState,
  columnFilters?: MRT_ColumnFiltersState
) {
  return useQuery<UnclaimedMoneyResponse>({
    queryKey: ["get-unclaimed-money", pagination, sorting, columnFilters], //refetch whenever params change
    queryFn: () =>
      getUnclaimedMoney({
        token,
        pagination,
        sorting,
        columnFilters,
      }),
    retry: false,
    keepPreviousData: true, //useful for paginated queries by keeping data from previous pages on screen while fetching the next page
  });
}

export default useGetUnclaimedMoney;
